import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Config } from '../app.config';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';



@Injectable()
export class ConfigService {
    _apiURI: string;
    urlOrigine: string;
    nbReservationCours = new BehaviorSubject<number>(0) ;
    nbReservationEspace = new BehaviorSubject<number>(0) ;
    activityicons = [
        'dance',
        'racket',
        'swimming-silhouette',
        'tapis',
        'yoga',
        'strong',
        'gymnastic-rings',
        'stationary-bike',
        'water',
        'two-boxing-gloves',
        'kickboxing',
        'zumba',
        'mat',
        'weight',
        'running',
        'cardio',
        'game',
        'timer',
        'ball',
        'team',
        'basketball',
        'squash',
        // 'pool-exercises',
        'kids-collectif',
        'zumba-1',
        'trx-suspension',
        'qi-gong',
        'rpm-sprint',
        'body-balance',
        'body-pump',
        'cross-training',
        'abs-workout',
        'abs-workout-2',
        'yoga-2',
        'yoga-2-water',

        // icon added
        'jump',
        'karate_adulte',
        'karate_enfant',
        'kick_boxing',
        'spinning',
        'swimming',
        'workout',

    ];
    constructor(@Inject(DOCUMENT) private document: Document, private config: Config) {
        this._apiURI =  'https://reservation.parklife.mg/resa-0.0.1-SNAPSHOT/resapark/'; // prod
    }

    getApiURI() {
        return this._apiURI;
    }

    getApiHost() {
        return this._apiURI.replace('resapark/', '');
    }

    getActivityIcons() {
        return this.activityicons;
    }

}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/shared/config.service.ts